import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="download-supplies-form"
export default class extends Controller {
  static targets = ["dateFields", "startDate", "endDate"];

  connect() {
    // Initialize state based on checkbox
    const checkbox = this.element.querySelector('input[type="checkbox"][name*="download_all"]');
    if (checkbox) {
      this.updateDateFields(checkbox.checked);
    }
  }

  toggleDateFields(event) {
    this.updateDateFields(event.target.checked);
  }

  updateDateFields(checked) {
    this.dateFieldsTargets.forEach((field) => {
      if (checked) {
        field.classList.add("hidden");
      } else {
        field.classList.remove("hidden");
      }
    });

    if (this.hasStartDateTarget) {
      this.startDateTarget.required = !checked;
      this.startDateTarget.disabled = checked;
      if (checked) {
        this.startDateTarget.value = "";
      }
    }

    if (this.hasEndDateTarget) {
      this.endDateTarget.required = !checked;
      this.endDateTarget.disabled = checked;
      if (checked) {
        this.endDateTarget.value = "";
      }
    }
  }
}

